module.exports = __webpack_public_path__ + "img/nueva-consola-demo.918b1210.jpg";